import { Link } from "react-router";

/**
 * Followups #7 — Cross-link button between the Job Config (formerly
 * "Processing Config", renamed in WU-10 / R-130) and Form Config surfaces of
 * a Job Type. Always renders the "open the other surface" affordance with a
 * chevron. The `currentSurface="processing"` identifier is preserved as the
 * internal name for the Job Config surface (avoiding a cross-cutting
 * rename); only the operator-facing label changed.
 */
interface Props {
  jobTypeId: string;
  currentSurface: "processing" | "form";
}

export function JobTypeSurfaceLink({ jobTypeId, currentSurface }: Props) {
  const target =
    currentSurface === "processing"
      ? { href: `/admin/forms/${jobTypeId}`, label: "Open Form Config →" }
      : { href: `/admin/job-types/${jobTypeId}`, label: "Open Job Config →" };

  return (
    <Link to={target.href} className="admin-link">
      {target.label}
    </Link>
  );
}
